/* eslint-disable */
import { TweenMax } from 'gsap/TweenMax'
import 'animation.gsap'
import { ScrollToPlugin } from 'ScrollToPlugin'
import ScrollMagic from 'scrollmagic'
import imagesLoaded from 'imagesloaded'

const plugins = [ScrollToPlugin]
const controller = new ScrollMagic.Controller()

// SlideToggle
function slideToggle (el, isOpen, duration) {
  const t = duration !== undefined ? duration : 0.3
  const options = {
    css: { height: 0 },
    ease: Power2.easeOut
  }
  if (isOpen) {
    el.style.height = ''
    options.onComplete = function () {
      el.style.height = ''
    }
    TweenMax.from(el, t, options)
    return
  }
  TweenMax.to(el, t, options)
}

controller.scrollTo(function (newpos, props) {
  let offset = props.offset
  let duration = props.duration

  if (isNaN(offset)) {
    const header = document.querySelector('.header')
    offset = header ? header.offsetHeight : 0
  }
  if (isNaN(duration)) {
    duration = 0.4
  }

  TweenMax.to(window, duration, {
    scrollTo: {
      y: newpos - offset,
      autoKill: false
    }
  })
})

function scrollToId (id, offset, duration) {
  const el = document.getElementById(id)
  if (!el) {
    return
  }
  controller.scrollTo('#' + id, { offset, duration })
}

function insideBreakpoint (breakpoint) {
  if (breakpoint) {
    const min = breakpoint.min || 0
    const max = breakpoint.max || Infinity
    return window.innerWidth >= min && window.innerWidth <= max
  }
  return true
}

// Sticky
class StickyEl {
  constructor (el, container, options) {
    this.el = el
    this.container = container
    this.options = options || {}
    if (!insideBreakpoint(this.options.breakpoint)) {
      return
    }
    this.createScene()
    // Refresh on resize
    window.addEventListener('resize', () => this.refresh(true))
    // Refresh on images loaded
    if (this.options.watchImagesLoad) {
      imagesLoaded(el, () => {
        setTimeout(() => {
          this.refresh(true)
        }, 100)
      })
    }
  }

  createScene () {
    const duration = this.container.offsetHeight - this.el.offsetHeight + (this.options.durationOffset || 0)
    this.scene = new ScrollMagic.Scene({
      triggerElement: this.container,
      triggerHook: this.options.triggerHook || 0,
      offset: this.options.offset || 0,
      duration: duration > 0 ? duration : 0
    })
      .setClassToggle(this.el, 'fixed')
      .setPin(this.el, {
        pushFollowers: false
      })
      .addTo(controller)
  }

  destroy () {
    if (!this.scene) {
      return
    }
    this.scene.removePin(true)
    this.el.classList.remove('fixed')
    controller.removeScene(this.scene)
  }

  refresh (isPinned) {
    if (!this.scene) {
      return
    }
    if (!insideBreakpoint(this.options.breakpoint)) {
      this.scene.destroy(true)
      return
    }
    const duration = this.container.offsetHeight - this.el.offsetHeight + (this.options.durationOffset || 0)
    this.scene
      .duration(duration > 0 ? duration : 0)
    if (!isPinned) {
      this.scene.setPin(this.el, {
        pushFollowers: false
      })
      controller.addScene(this.scene)
    }
  }
}

export {
  scrollToId, StickyEl, slideToggle
}
